import React from "react";
import { cn } from "tools/ui";

function CardBasic({ onClick, children, style }) {
  return (
    <div
      className={cn(
        `bg-white rounded-xl w-full shadow-lg p-4 my-6 hover:cursor-pointer`,
        style,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

export default CardBasic;
